import { Component, ViewEncapsulation, Input } from '@angular/core';
import { ErrorComponentDefinition } from '@formbird/types';

import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'ft-component-error',
  templateUrl: './component-error.component.html',
  styleUrls: ['./component-error.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  imports: [MatCardModule]
})
export class ComponentErrorComponent {
  @Input() componentDefinition: ErrorComponentDefinition;
}
